import React, {useEffect, useRef, useState} from "react";
import {getPackageInternalUrl} from "../../constants/appRoutes";
import useOnScreen from "../../hooks/useOnScreen";
import PackageCard from "../package-card";
import {CATALOG_NAVIGATION_MODE_GRID} from "../settings-select/nodes-settings/node-settings-form";

const PackageList = ({packages, node, catalogNavigationMode, query, catalog, initialPageSize = 50, pageSize = 30}) => {
  const [pageCount, setPageCount] = useState(0);
  const scrollSensorRef = useRef(null);
  const scrollSensorIsOnScreen = useOnScreen(scrollSensorRef);

  useEffect(() => {
    setPageCount(0);
  }, [packages]);

  useEffect(() => {
    if (scrollSensorIsOnScreen) {
      setPageCount(prevVal => prevVal + 1);
    }
  }, [scrollSensorIsOnScreen]);

  return (
    <>
      {packages.slice(0, initialPageSize + pageCount * pageSize).map((pkg, idx) => (
        <PackageCard
          key={idx}
          to={getPackageInternalUrl(node.code, pkg.categoryPath, pkg.identifier, undefined)}
          nodeId={node.nodeId}
          packageId={pkg.identifier}
          package={pkg}
          xs={12}
          md={catalogNavigationMode === CATALOG_NAVIGATION_MODE_GRID ? 4 : 12}
          isMultiCategorized={
            !!query && JSON.stringify(catalog?.categoryGroups || {}).split(pkg.identifier).length - 1 > 1
          }
        />
      ))}
      <div ref={scrollSensorRef} style={{height: "50px"}}></div>
    </>
  );
};

export default PackageList;
